import type { AppIndexEntry } from "playground/apps/index/app-index";
import { appEntrypoint, resolveAppPage } from "playground/apps/manifest";

import { JIG_RUNTIME } from "./install";

/** One launch contract shared by navigation, native views, and iframe hosts. */
export function jigWindow(
  entry: AppIndexEntry,
  view = "page",
): { kind: "native" | "program"; module: string } | null {
  if (!entry.manifest) return null;
  const native = appEntrypoint(entry.manifest, JIG_RUNTIME);
  if (native) return { kind: "native", module: native.entry.module };
  const page = resolveAppPage(
    appEntrypoint(entry.manifest, view)?.entry.module,
  );
  return page.kind === "program"
    ? { kind: "program", module: page.entry }
    : null;
}
